export function buildOrgComplianceLevelsRadioListItems(complianceLevels) {
  return Object.entries(complianceLevels).map(([key, level]) => ({
    key,
    displayText: level.title,
    description: level.description,
  }));
}
